export class ClassificationType {
  public id: string;
  public name: string;
  public classificationOnForm: boolean;
  public useCustomOrder: boolean = true;
  public useCustomKey: boolean;
  public useInConstants: boolean;
  public useGroupsForSubCatalogs: boolean;
  public showGroups: boolean = false;
  public isRejectionCatalog: boolean = false;
  public serviceIds: string[] = [];
  public fieldNumber: number;
  public services: string;
  public businessKey: string;
}
